import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { VizFormModule } from '../common/components/form/form.module';
import { utils } from '../common/utils';
import { AppValidators } from '../common/validators';


@Component({
  selector: 'app-booking-export-dialog',
  templateUrl: './booking.export.dialog.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FontAwesomeModule,
    VizFormModule,
    MatSlideToggleModule,
  ],
})
export class BookingExportDialogComponent {
  _common = _common;
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<BookingExportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      start: ['', Validators.required],
      end: ['', Validators.required],
      checkinTime: [false]
    }, {
      validators: [
        AppValidators.dateRange(
          'start',
          'end',
          'From',
          'To',
          180,
        ),
      ],
    }
    );
  }

  onCancel() {
    this.dialogRef.close();
  }

  save() {
    if (!this.form.valid) {
      return utils.validateAllFormFields(this.form);
    }
    this.dialogRef.close(this.form.value);

  }
} 